module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n<app-nav></app-nav>\n<app-introduction></app-introduction>\n<app-i-love ></app-i-love>\n<app-experience></app-experience>\n<app-my-work ></app-my-work>\n<app-refs-and-coworkers id=\"references\"></app-refs-and-coworkers>\n<app-contact></app-contact>\n<app-footer></app-footer>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /Users/jontryggviunnarsson/Dropbox/Mamp/elective-angular-2018/api/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main